// userController.tsx
import { JSX, useCallback, useEffect, useMemo, useState } from "react";
import { OptionType } from "../../common/component/InputSelect";
import { renderField } from "../../common/utils/renderField";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useApiHandler } from "../../common/utils/customapiHandler";
import useFetch from "../../hooks/useFetch";
import { showErrorToast } from "../../common/component/Toaster";
import { useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
// import { all } from "axios";

interface SelectOptions {
  branch: { [key: number]: OptionType[] };
  account: { [key: number]: OptionType[] };
  mastersacc: { [key: number]: OptionType[] };
  item: { [key: number]: OptionType[] };
  salesman: { [key: number]: OptionType[] };
  accountOF: { [key: number]: OptionType[] };
  selectedaccount: { [key: number]: OptionType[] };
  optionalField: { [key: number]: OptionType[] };
  userType: { [key: number]: OptionType[] };
  loading: boolean;
  error: string | null;
}

export const userController = () => {
  const form = useForm<any>({
    mode: "onBlur",
    defaultValues: {
      name: "",
      userName: "",
      userType: null,
      salesman: null,
      password: "",
      share: 0,
      allAccount: 1,
      allBranch: 1,
      allSelected: 1,
      accountOF: [],
      export: 0,
      show: 0,
      isActive: 1,
      allItemGrp: 1,
      allMasterSeries: 1,
      DBFinancialR: 0,
      DBNetSaleR: 1,
      DBNetPurcR: 0,
      DBExpenseR: 0,
      DBCriticalLR: 0,
      DBAgeingRFifoR: 1,
      DBAgeingPFifoR: 0,
      DBPendingSOR: 0,
      DBPendingPOR: 0,
      DBBalanceBR: 0,
      DBBalanceCashR: 0,
      DBOrdSalesR: 1,
      DBTopCustomerR: 1,
      DBStateWDataR: 1,
      DBTopStatesR: 1,
      DBTopSalesmanR: 1,
      DBTopProductR: 1,
      DBTopCategoryR: 1,
      menuRights: [],
      accountSelections: [],
      branchSelections: [],
      itemSelections: [],
      optionalSelections: [],
      selectedAccountSelections: [],
      masterSeriesSelection:[],
    },
  });

  const location = useLocation();
  const navigate = useNavigate();
  const route = all_routes;
  const code = location?.state?.code;
  const callFetch = useFetch();
  const { decryptedData } = useSelector((state: RootState) => state.authData);
  const { CompCode, FinYear, ID } = decryptedData || {};
  const { loadDropdownOptions, submitHandler, modifyDataHandler } =
    useApiHandler();

  const [enableBranch, setEnableBranch] = useState(false);
  const [sideBarData, setSideBarData] = useState<any[]>([]);
  const [modifyUserData, setModifyUserData] = useState<any>(null);

  const [selectOptions, setSelectOptions] = useState<SelectOptions>({
    branch: {},
    account: {},
    selectedaccount: {},
    mastersacc:{},
    item: {},
    salesman: {},
    accountOF: {},
    optionalField: {},
    userType: {},
    loading: false,
    error: null,
  });

  // ==================== FETCH DROPDOWN OPTIONS ====================
  const fetchSelectOptions = useCallback(async () => {
    const optionTypes = [
      "branch",
      "account",
      "item",
      "userType",
      "salesman",
      "accountOF",
      "selectedaccount",
      "mastersacc",
    ] as const;

    const urls: Record<(typeof optionTypes)[number], string> = {
      branch: `Report/GetBusyMast?CompCode=${CompCode}&FY=${FinYear}&MasterType=24&RecType=0&VchType=0`,
      account: `Report/GetBusyMast?CompCode=${CompCode}&FY=${FinYear}&MasterType=1&RecType=0&VchType=0`,
      selectedaccount: `Report/GetBusyMast?CompCode=${CompCode}&FY=${FinYear}&MasterType=2&RecType=0&VchType=0`,
      item: `Report/GetBusyMast?CompCode=${CompCode}&FY=${FinYear}&MasterType=5&RecType=0&VchType=0`,
      salesman: `Report/GetBusyMast?CompCode=${CompCode}&FY=${FinYear}&MasterType=19&RecType=0&VchType=0`,
      userType: `Report/GetBusyMaster?CompCode=${CompCode}&FY=${FinYear}&MasterType=1015&RecType=0&VchType=0&UserID=${ID || 0}`,
      accountOF: `Report/GetBusyMaster?CompCode=${CompCode}&FY=${FinYear}&MasterType=1017&RecType=0&VchType=0&UserID=${ID || 0}`,
      mastersacc: `Report/GetBusyMaster?CompCode=${CompCode}&FY=${FinYear}&MasterType=26&RecType=0&VchType=0&UserID=${ID || 0}`,
    };

    try {
      setSelectOptions((prev) => ({ ...prev, loading: true, error: null }));
      for (const fieldType of optionTypes) {
        await loadDropdownOptions({
          url: urls[fieldType],
          setState: (options: OptionType[]) =>
            setSelectOptions((prev) => ({
              ...prev,
              [fieldType]: { ...prev[fieldType], 0: options },
            })),
          setLoading: (loading: any) =>
            setSelectOptions((prev) => ({ ...prev, loading })),
          valueKey: "Code",
          labelKey: "Name",
          additionalKeys: ["NameAlias"],
        });
      }
      setSelectOptions((prev) => ({ ...prev, loading: false }));
    } catch (error) {
      console.error("Failed to fetch options:", error);
      setSelectOptions((prev) => ({
        ...prev,
        loading: false,
        error:
          error instanceof Error ? error.message : "Failed to fetch options",
      }));
    }
  }, [loadDropdownOptions, CompCode, FinYear, ID]);

  // ==================== FILTER INCLUDED OPTIONAL FIELDS ====================
  const includedOptionalFields = useMemo(() => {
    const allOptionalFields: OptionType[] =
      selectOptions.optionalField?.[0] || [];
    const selectedOptionalFields: { Code: any }[] =
      form.watch("optionalSelections") || [];

    if (!selectedOptionalFields.length || !allOptionalFields.length) {
      return [];
    }

    const selectedCodes = new Set(selectedOptionalFields.map((item) => item.Code));
    return allOptionalFields.filter((option) => selectedCodes.has(option.value));
  }, [selectOptions.optionalField, form.watch("optionalSelections")]);

  // ==================== SAVE / SUBMIT ====================
  const handleSave = useCallback(
    async (data: any) => {
      try {
        const userROFPayload = (includedOptionalFields || []).map((item) => ({
          Code: item.value,
          Name: item.label,
        }));

        const payload = {
          ID: code || 0,
          Name: data?.name,
          UserName: data?.userName,
          Password: data?.password,
          IsActive: data?.isActive,
          UserTypeID: data?.userType?.value || 0,
          UserType: data?.userType?.label || "",
          MasterCode: data?.salesman?.value || 0,
          Share: data?.share,
          Export: data?.export,
          ShowValue: data?.show,
          AllBranch: data?.allBranch,
          AllItem: data?.allItemGrp,
          AllAccount: data?.allAccount,
          AllMasterS: data?.allMasterSeries,
          SelectedAcc: data?.allSelected,
          AccOF: data?.accountOF?.value ?? 0, //optional field
          Branch: data?.branchSelections || [],
          ItemGroup: data?.itemSelections || [],
          AccountGroup: data?.accountSelections || [],
          Account: data?.selectedAccountSelections || [],
          MasterSeries:data?.masterSeriesSelection ||[],
          UserROF: userROFPayload,
          UserRight: data?.menuRights || [],
          DBUserRights: {
            DBFinancialR: data?.DBFinancialR || 0,
            DBNetSaleR: data?.DBNetSaleR || 0,
            DBNetPurcR: data?.DBNetPurcR || 0,
            DBExpenseR: data?.DBExpenseR || 0,
            DBCriticalLR: data?.DBCriticalLR || 0,
            DBAgeingRFifoR: data?.DBAgeingRFifoR || 0,
            DBAgeingPFifoR: data?.DBAgeingPFifoR || 0,
            DBPendingSOR: data?.DBPendingSOR || 0,
            DBPendingPOR: data?.DBPendingPOR || 0,
            DBBalanceBR: data?.DBBalanceBR || 0,
            DBBalanceCashR: data?.DBBalanceCashR || 0,
            DBOrdSalesR: data?.DBOrdSalesR || 0,
            DBTopCustomerR: data?.DBTopCustomerR || 0,
            DBStateWDataR: data?.DBStateWDataR || 0,
            DBTopStatesR: data?.DBTopStatesR || 0,
            DBTopSalesmanR: data?.DBTopSalesmanR || 0,
            DBTopProductR: data?.DBTopProductR || 0,
            DBTopCategoryR: data?.DBTopCategoryR || 0,
          },
        };

        console.log("payload", payload);
        const url = `Report/SaveUser?CompCode=${CompCode}`;
        await submitHandler({
          url,
          method: "POST",
          data: payload,
          setLoading: (loading: any) =>
            setSelectOptions((prev) => ({ ...prev, loading })),
          onSuccess: () => {
            form.reset();
            navigate(route.userlist, {
              state: location?.state?.navigate || location?.state,
            });
          },
          onError: (error: unknown) => {
            console.error("Error saving form:", error);
            showErrorToast("Failed to save receipt");
          },
        });
      } catch (error) {
        console.error("Error saving user:", error);
      }
    },
    [
      submitHandler,
      CompCode,
      form,
      navigate,
      route.userlist,
      location?.state,
      includedOptionalFields,
    ]
  );

  // ==================== FETCH OPTIONAL FIELD ====================
  const fetchOptionalFieldByMasterType = useCallback(
    async (masterType: number) => {
      if (!masterType) return;
      const url = `Report/GetBusyMast?CompCode=${CompCode}&FY=${FinYear}&MasterType=${masterType}&RecType=0&VchType=0`;
      try {
        setSelectOptions((prev) => ({ ...prev, loading: true }));
        await loadDropdownOptions({
          url,
          setState: (options: OptionType[]) =>
            setSelectOptions((prev) => ({
              ...prev,
              optionalField: { ...prev.optionalField, 0: options },
            })),
          setLoading: (loading: any) =>
            setSelectOptions((prev) => ({ ...prev, loading })),
          valueKey: "Code",
          labelKey: "Name",
          additionalKeys: ["NameAlias"],
        });
        setSelectOptions((prev) => ({ ...prev, loading: false }));
      } catch (error) {
        console.error("Failed to fetch optional fields:", error);
        setSelectOptions((prev) => ({
          ...prev,
          loading: false,
          error:
            error instanceof Error
              ? error.message
              : "Failed to fetch optional fields",
        }));
      }
    },
    [CompCode, FinYear, loadDropdownOptions]
  );

  // ==================== FETCH MODIFY DATA ====================
  const fetchModifyData = useCallback(
    async (usercode: number) => {
      if (usercode === undefined || usercode === null || usercode === 0) return;
      try {
        await modifyDataHandler({
          url: `Report/GetUserMaster?UserID=${usercode}&CompCode=${CompCode}&FY=${FinYear}`,
          setLoading: (loading: any) =>
            setSelectOptions((prev) => ({ ...prev, loading })),
          onSuccess: (data) => {
            const {
              Name,
              UserName,
              Password,
              UserTypeID,
              UserType,
              Share,
              Export,
              ShowValue,
              IsActive,
              AllItem,
              AllBranch,
              AllAccount,
              AllMasterS,
              SelectedAcc,
              Account,
              AccOF,
              AccOFName,
              UserROF, // optional field (array of IDs)
              MasterCode,
              MasterName,
              ItemGroup,
              AccountGroup,
              MasterSeries,
              Branch,
              DBUserRights,
            }: any = data;

            console.log("Modify-Data", data);

            // Convert server arrays to safe primitive arrays (IDs)
            const branchSelections = Array.isArray(Branch)
              ? Branch.map((id: any) => id)
              : [];

            const accountSelections = Array.isArray(AccountGroup)
              ? AccountGroup.map((id: any) => id)
              : [];

            const itemSelections = Array.isArray(ItemGroup)
              ? ItemGroup.map((id: any) => id)
              : [];

            const selectedAccountSelections = Array.isArray(Account)
              ? Account.map((id: any) => id)
              : [];

            const masterSeriesSelections = Array.isArray(MasterSeries)
              ? MasterSeries.map((id: any) => id)
              : [];

            // const optionalSelectionsFromServer = Array.isArray(UserROF)
            //   ? UserROF.map((id: any) => id)
            //   : [];

            const optionalSelectionsFromServer = Array.isArray(UserROF)
              ? UserROF.map((item: any) => ({
                Code: item.Code,
                Name: item.Name,
              }))
              : [];


            // Reset the form with basic values. For optionalSelections store raw IDs so we can map them to option objects later
            form.reset({
              name: Name || "",
              userName: UserName || "",
              userType: { value: UserTypeID || 0, label: UserType || "" },
              salesman: { value: MasterCode || 0, label: MasterName || "" },
              password: Password || "",
              share: Share || 0,
              allAccount: AllAccount || 0,
              allBranch: AllBranch || 0,
              allSelected: SelectedAcc || 0,
              allMasterSeries: AllMasterS || 0,
              accountOF: { value: AccOF || 0, label: AccOFName || "" },
              export: Export || 0,
              show: ShowValue || 0,
              isActive: IsActive || 0,
              allItemGrp: AllItem || 0,
              accountSelections: accountSelections,
              branchSelections: branchSelections,
              itemSelections: itemSelections,
              selectedAccountSelections: selectedAccountSelections,
              masterSeriesSelection: masterSeriesSelections,
              // store raw IDs here temporarily
              optionalSelections: optionalSelectionsFromServer,
              DBFinancialR: DBUserRights?.DBFinancialR,
              DBNetSaleR: DBUserRights?.DBNetSaleR || 0,
              DBNetPurcR: DBUserRights?.DBNetPurcR || 0,
              DBExpenseR: DBUserRights?.DBExpenseR || 0,
              DBCriticalLR: DBUserRights?.DBCriticalLR || 0,
              DBAgeingRFifoR: DBUserRights?.DBAgeingRFifoR || 0,
              DBAgeingPFifoR: DBUserRights?.DBAgeingPFifoR || 0,
              DBPendingSOR: DBUserRights?.DBPendingSOR || 0,
              DBPendingPOR: DBUserRights?.DBPendingPOR || 0,
              DBBalanceBR: DBUserRights?.DBBalanceBR || 0,
              DBBalanceCashR: DBUserRights?.DBBalanceCashR || 0,
              DBOrdSalesR: DBUserRights?.DBOrdSalesR || 0,
              DBTopCustomerR: DBUserRights?.DBTopCustomerR || 0,
              DBStateWDataR: DBUserRights?.DBStateWDataR || 0,
              DBTopStatesR: DBUserRights?.DBTopStatesR || 0,
              DBTopSalesmanR: DBUserRights?.DBTopSalesmanR || 0,
              DBTopProductR: DBUserRights?.DBTopProductR || 0,
              DBTopCategoryR: DBUserRights?.DBTopCategoryR || 0,
            });

            // CRITICAL: store the full fetched payload so other effects can map fields (like optional selections)
            setModifyUserData(data);
          },
          onError: (error: unknown) => {
            console.error("Error fetching user data:", error);
          },
        });
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
    [modifyDataHandler, form, CompCode, FinYear]
  );

  // ==================== SYNC MODIFY DATA WITH OPTIONAL FIELD OPTIONS ====================
  // Map modifyUserData.UserROF (IDs) -> actual option objects from selectOptions.optionalField[0]

  // useEffect(() => {
  //   // Wait until we have both modifyUserData and optionalField options
  //   if (!modifyUserData) return;
  //   const optionList: OptionType[] = selectOptions.optionalField?.[0] || [];
  //   if (!Array.isArray(optionList) || optionList.length === 0) {
  //     // Nothing to map yet
  //     return;
  //   }

  //   const serverIds: any[] = Array.isArray(modifyUserData.UserROF)
  //     ? modifyUserData.UserROF
  //     : [];

  //   if (serverIds.length === 0) {
  //     // Clear optionalSelections explicitly if server returned empty
  //     form.setValue("optionalSelections", [], {
  //       shouldDirty: false,
  //       shouldTouch: false,
  //     });
  //     return;
  //   }

  //   // Map IDs -> option objects (value,label) using optionList
  //   // Keep server order
  //   const orderedMatchedOptions: OptionType[] = serverIds
  //     .map((id: any) => optionList.find((opt) => opt.value === id))
  //     .filter(Boolean) as OptionType[];

  //   // If some server IDs didn't have a match in optionList, we can optionally create fallback options:
  //   const missingIds = serverIds.filter(
  //     (id: any) => !orderedMatchedOptions.some((opt) => opt.value === id)
  //   );
  //   if (missingIds.length > 0) {
  //     // create fallback option objects using id as value and id as label (or blank)
  //     const fallbackOptions = missingIds.map(
  //       (id: any) =>
  //       ({
  //         value: id,
  //         label: String(id),
  //       } as OptionType)
  //     );
  //     // Append fallback options in the positions of missing ids (preserve order)
  //     const finalOptions: OptionType[] = serverIds.map((id: any) => {
  //       const found = orderedMatchedOptions.find((o) => o.value === id);
  //       if (found) return found;
  //       const fb = fallbackOptions.find((f) => f.value === id);
  //       return fb!;
  //     });
  //     form.setValue("optionalSelections", finalOptions, {
  //       shouldDirty: false,
  //       shouldTouch: false,
  //     });
  //   } else {
  //     // All matched
  //     form.setValue("optionalSelections", orderedMatchedOptions, {
  //       shouldDirty: false,
  //       shouldTouch: false,
  //     });
  //   }
  // }, [modifyUserData, selectOptions.optionalField, form]);


  useEffect(() => {
    if (!modifyUserData) return;
    const optionList: OptionType[] = selectOptions.optionalField?.[0] || [];
    if (!Array.isArray(optionList) || optionList.length === 0) {
      return;
    }

    const currentSelections = form.getValues("optionalSelections");

    if (!Array.isArray(currentSelections) || currentSelections.length === 0) {
      form.setValue("optionalSelections", [], {
        shouldDirty: false,
        shouldTouch: false,
      });
      return;
    }

    const finalOptions = currentSelections.map((selected: any) => {
      const foundOption = optionList.find((opt) => opt.value === selected.Code);
      return {
        Code: selected.Code,
        Name: foundOption ? foundOption.label : selected.Name || String(selected.Code),
      };
    });

    form.setValue("optionalSelections", finalOptions, {
      shouldDirty: false,
      shouldTouch: false,
    });
  }, [modifyUserData, selectOptions.optionalField, form]);


  // ==================== OTHER API CALLS ====================
  const enableBranchChecking = useCallback(async () => {
    const url = `Report/GetBranchEnableInBusy?CompCode=${CompCode}&FY=${FinYear}`;
    try {
      const { res, got }: any = await callFetch(url, "GET");
      if (res.status === 200 && got.Status === 1) {
        setEnableBranch(got.BranchEnable || "");
      }
    } catch (error) {
      console.error("Error loading branch enable:", error);
    }
  }, [callFetch, CompCode, FinYear]);

  const getUserRightTree = useCallback(
    async (userCode: number, uType: number) => {
      try {
        const url = `Report/GetUserMenusTree?UserID=${userCode}&CompCode=${CompCode}&FY=${FinYear}&UserType=${uType}`;
        const { res, got }: any = await callFetch(url, "GET");
        if (res?.status === 200 && got.Status === 1) {
          setSideBarData(got?.Data);
        }
      } catch (error) {
        console.error("Error loading rights tree:", error);
      }
    },
    [callFetch, CompCode, FinYear]
  );

  // ==================== MAIN EFFECTS ====================
  const accountOFWatch = form.watch("accountOF");
  const userTypeWatch = form.watch("userType");
  const optionalWatch = form.watch("optionalSelections");
  const mastersWatch = form.watch("masterSeriesSelection");


  useEffect(() => {
    if (CompCode && FinYear) {
      fetchSelectOptions();
      enableBranchChecking();
    }
  }, [fetchSelectOptions, enableBranchChecking, CompCode, FinYear]);

  useEffect(() => {
    if (CompCode && FinYear && code) {
      fetchModifyData(code);
    }
  }, [fetchModifyData, CompCode, FinYear, code]);

  useEffect(() => {
    if (accountOFWatch?.value) {
      fetchOptionalFieldByMasterType(accountOFWatch.value);
    }
  }, [accountOFWatch, fetchOptionalFieldByMasterType]);

  // useEffect(() => {
  //   form.setValue("optionalSelections", [], {
  //     shouldDirty: false, // Prevents triggering dirty state just by changing the dropdown
  //     shouldTouch: false,
  //   });
  // }, [accountOFWatch, form])

  useEffect(() => {
    if (CompCode && FinYear) {
      getUserRightTree(code || 0, userTypeWatch?.value || 0);
    }
  }, [getUserRightTree, CompCode, FinYear, code, userTypeWatch?.value]);

  // ==================== UTILITIES ====================
  const optionsMap = useMemo<Record<string, OptionType[]>>(
    () => ({
      branch: selectOptions.branch[0] || [],
      account: selectOptions.account[0] || [],
      item: selectOptions.item[0] || [],
      salesman: selectOptions.salesman[0] || [],
      userType: selectOptions.userType[0] || [],
      accountOF: selectOptions.accountOF[0] || [],
      optionalField: selectOptions.optionalField[0] || [],
      selectedaccount: selectOptions.selectedaccount[0] || [],
      mastersacc: selectOptions.mastersacc[0] || [],
    }),
    [selectOptions]
  );

  const getSelectOptions = useCallback(
    (
      fieldType:
        | "branch"
        | "account"
        | "item"
        | "userType"
        | "salesman"
        | "accountOF"
        | "optionalField"
        | "selectedaccount"
        | "mastersacc"
    ) => optionsMap[fieldType] || [],
    [optionsMap]
  );

  const renderFieldWrapper = useCallback(
    (field: any, key: string): JSX.Element | null => {
      const options =
        field.component === "InputSelect"
          ? getSelectOptions(
            field.props.name as
            | "branch"
            | "account"
            | "item"
            | "userType"
            | "salesman"
            | "accountOF"
            | "optionalField"
            |"mastersacc"

          )
          : [];
      return renderField({
        field,
        form,
        options,
        key,
      });
    },
    [form, getSelectOptions]
  );

  // ==================== RETURN ====================
  return {
    renderFieldWrapper,
    form,
    getSelectOptions,
    sideBarData,
    handleSave,
    CompCode,
    location: location.state?.navigate || location?.state,
    loading: selectOptions?.loading,
    enableBranch,
    accountOFWatch,
    optionalWatch,
    mastersWatch
  };
};
